module.exports = __webpack_public_path__ + "static/media/crowns.2e4d0bbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/crowns.svg
// module id = 72
// module chunks = 0